module.exports = __webpack_public_path__ + "static/media/yellowStar.2900d99a.svg";